import request from '@/utils/request';
import { freightInfoType } from './data'

export async function getFreightInfoUrl(params:freightInfoType): Promise<any> {
    return request({
        url: '/seller/v1/order/freightCalculation',
        method: 'POST',
        data: params,
    });
}